import styled, { css } from 'styled-components';
import { DEVICES } from '_constants';
import { UiColors } from 'assets/styles/old/global';

const titleType = (type) => {
  switch (type) {
    case 'modal':
      return css`
        font-size: 22px;
        font-style: bold;
        font-weight: 800;
        line-height: 0;
      `;
    case 'retailer':
      return css`
        font-size: 20px;
        font-style: bold;
        font-weight: 600;

        @media ${DEVICES.tablet} {
          font-size: 18px;
          font-weight: 500;
          line-heihgt: 30px;
        }
      `;
    default:
      return css`
        font-size: 26px;
        font-style: normal;
        line-height: 26px;
      `;
  }
};

const Title = styled.h1.attrs(() => ({ ariaRequired: true }))`
  font-family: Roboto;
  line-height: 32px;
  font-weight: 800;
  text-align: left;

  color: ${UiColors.blackFillColor};
  ${({ validValue }) => titleType(validValue)};
`;

const TitleH1 = styled.h1`
  font-family: Roboto;
  font-size: 26px;
  line-height: 26px;
  text-align: center;
  margin: 0;
  color: ${UiColors.blackFillColor};
`;

const containerType = (type) => {
  switch (type) {
    case 'login':
      return css`
        justify-content: center;
        margin-bottom: 50px;
      `;
    case 'policy':
      return css`
        margin: 24px 0 33px 0;
        font-style: normal;
        font-weight: 700;

        @media ${DEVICES.mobileM} {
          ${Title} {
            font-size: 21px;
          }
        }
      `;
    case 'reset':
      return css`
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
        justify-content: center;
        margin-bottom: 16px;
      `;
    default:
      return css`
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 26px;
      `;
  }
};

const TitleContainer = styled.div.attrs(() => ({ ariaRequired: true }))`
  display: flex;
  ${({ type }) => containerType(type)};
`;

const SubTitle = styled.div.attrs(() => ({
  ariaRequired: true,
}))`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: ${UiColors.dimGreyFillColor};
  height: 35px;
  margin-bottom: 18px;
`;

const ContentText = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${UiColors.blackFillColor};

  h2 {
    font-size: 18px;
    margin-top: 50px;
    margin-bottom: 15px;
  }
`;

const ContentTextTitle = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 26px;
  color: ${UiColors.blackFillColor};
  margin: 21px 0 9px 0;
`;

export { Title, TitleH1, TitleContainer, ContentText, SubTitle, ContentTextTitle };
